import React, { Fragment } from 'react';
import Container from '../../Basic/Container/Container.mjs';
import DesktopOnly from '../../Containers/DesktopOnly/DesktopOnly.mjs';
import MobileOnly from '../../Containers/MobileOnly/MobileOnly.mjs';
import HorizontalCarousel from '../../UIElements/HorizontalCarousel/HorizontalCarousel.mjs';
import SmallMediaCard from '../../UIElements/SmallMediaCard/SmallMediaCard.mjs';
import { StyledLineSeparator } from './TopVideos.styles.mjs';
import { useTheme } from 'styled-components';

const TopVideos = ({ stories }) => {
    const theme = useTheme();
    const mediaCardJsxList = stories.map(story => (React.createElement(SmallMediaCard, { key: story.id, heading: story.heading, thumbnail: {
            alt: story.heading,
            src: story.thumbnail
        }, durationTime: story.durationTime, href: "#" })));
    return (React.createElement(Container, null,
        React.createElement(DesktopOnly, { breakpoint: theme.breakpoints.sm }, mediaCardJsxList.map((mediaCardJsx, index) => (React.createElement(Fragment, { key: index },
            index > 0 && React.createElement(StyledLineSeparator, null),
            mediaCardJsx)))),
        React.createElement(MobileOnly, { breakpoint: theme.breakpoints.sm },
            React.createElement(HorizontalCarousel, null, mediaCardJsxList))));
};

export { TopVideos as default };
//# sourceMappingURL=TopVideos.mjs.map
